const headRowsInvitationsUsers = {
  email: 'E-mail',
  role: 'Type of Access',
  site: 'Site',
  createdAt: 'Sent On',
  invitation: 'Link'
};

export default headRowsInvitationsUsers;
